import { ENDPOINTS, getFullUrl } from "./config";
import { Clinic } from "../../types/clinic";
export class ClinicService {
  static getToken(): string | null {
    return localStorage.getItem("token");
  }

  static async addNewClinic(dataList: Clinic | FormData) {
    try {
      const isFormData = dataList instanceof FormData;

      const response = await fetch(getFullUrl(ENDPOINTS.CLINIC.ADD), {
        method: "POST",
        headers: isFormData
          ? { Authorization: `Bearer ${this.getToken()}` }
          : {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.getToken()}`,
            },
        body: isFormData ? dataList : JSON.stringify(dataList),
      });

      const data = await response.json();
      return data;
    } catch (error) {
      return {
        success: false,
        message:
          error instanceof Error ? error.message : "Failed to create clinic",
      };
    }
  }

  static async getSupervisorsDropdown() {
    try {
      const response = await fetch(
        getFullUrl(ENDPOINTS.CLINIC.CLINICDROPDOWN),
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.getToken()}`,
          },
        }
      );

      const data = await response.json();
      return data;
    } catch (error) {
      return {
        success: false,
        message:
          error instanceof Error
            ? error.message
            : "Failed to fetch supervisors",
      };
    }
  }

  static async updateExistingClinic(
    clinicId: string,
    dataList: Clinic | FormData
  ) {
    try {
      const isFormData = dataList instanceof FormData;

      const response = await fetch(
        getFullUrl(ENDPOINTS.CLINIC.UPDATE.replace(":clinicId", clinicId)),
        {
          method: "PUT",
          headers: isFormData
            ? { Authorization: `Bearer ${this.getToken()}` }
            : {
                "Content-Type": "application/json",
                Authorization: `Bearer ${this.getToken()}`,
              },
          body: isFormData ? dataList : JSON.stringify(dataList),
        }
      );

      const data = await response.json();
      return data;
    } catch (error) {
      return {
        success: false,
        message:
          error instanceof Error ? error.message : "Failed to create clinic",
      };
    }
  }

  static async deleteExistingClinic(clinicId: string) {
    try {
      const url = `${getFullUrl(
        ENDPOINTS.CLINIC.DELETE
      )}?id=${clinicId}&role=${"Clinic"}`;
      const response = await fetch(url, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${this.getToken()}`,
        },
      });

      const data = await response.json();
      return data;
    } catch (error) {
      return {
        success: false,
        message:
          error instanceof Error ? error.message : "Failed to delete Clinic",
      };
    }
  }

  // Update clinic Image
  static async DeleteClinicImage(clinicId: string) {
    try {
      const response = await fetch(
        getFullUrl(
          ENDPOINTS.CLINIC.DELETEPROFILEIMAGE.replace(":clinicId", clinicId)
        ),
        {
          method: "PUT", 
          headers: {
            Authorization: `Bearer ${this.getToken()}`, 
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error(
          `Failed to delete clinic image. Status: ${response.status}`
        );
      }

      return await response.json();
    } catch (error) {
      return {
        success: false,
        message:
          error instanceof Error
            ? error.message
            : "Failed to delete clinic image",
      };
    }
  }

  static async getClinics({
    page = 1,
    pageSize = 10,
    searchText=""
  }: {
    page?: number;
    pageSize?: number;
    searchText: string
  }): Promise<{
    success: boolean;
    message?: string;
    data?: {
      dataList: Clinic[];
      totalItemsCount: number;
      totalPages: number;
      currentPage: number;
    };
  }> {
    try {
      const url = new URL(getFullUrl(ENDPOINTS.CLINIC.GETLIST));

      url.searchParams.append("page", page.toString());
      url.searchParams.append("pageSize", pageSize.toString());
      url.searchParams.append("searchText", searchText.toString());

      console.log("📡 API Request URL (Clinics):", url.toString());

      const response = await fetch(url.toString(), {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.getToken()}`,
          "Cache-Control": "no-cache",
        },
      });

      const data = await response.json();
      return {
        success: data.success,
        message: data.message,
        data: {
          dataList: data.data?.dataList || [],
          totalItemsCount: data.data?.totalItemsCount || 0,
          totalPages: data.data?.totalPages || 1,
          currentPage: data.data?.currentPage || page,
        },
      };
    } catch (error) {
      console.error("❌ Error in getClinics:", error);
      return {
        success: false,
        message:
          error instanceof Error ? error.message : "Failed to load clinics",
      };
    }
  }
}
